export * from "./store";
export * from "./state";

import { createStore } from "./store";
export const store = createStore();



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/store/index.ts